<ng-container>
  <ion-header class="ion-no-border header">
    <ion-toolbar>
      <ion-label class="title" data-cy="select-customer-label">
        {{ 'Select Territory' | translate }}
      </ion-label>
      <ion-buttons slot="end" *ngIf="isDesktop">
        <ion-button data-cy="close-modal-button" (click)="close()">
          <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <cdk-virtual-scroll-viewport
      class="territory-list"
      itemSize="79"
      minBufferPx="800"
      maxBufferPx="1000"
    >
      <ion-list class="territory-list" *ngIf="territories.length">
        <ion-item *cdkVirtualFor="let territory of territories; let i = index">
          <ion-label class="list-row">
            <ng-container
              *ngIf="i === 0"
              [ngTemplateOutlet]="myTerritory"
            ></ng-container>
            <ng-container
              *ngIf="i === 1"
              [ngTemplateOutlet]="selectAll"
            ></ng-container>
            <ng-container
              *ngIf="i > 1"
              [ngTemplateOutlet]="mainItem"
              [ngTemplateOutletContext]="{ territory: territory }"
            >
            </ng-container>
          </ion-label>
          <ion-checkbox slot="end"> </ion-checkbox>
        </ion-item>
      </ion-list>
    </cdk-virtual-scroll-viewport>
  </ion-content>

  <ion-footer
    class="customer-selection-footer"
    [ngClass]="
      isTablet
        ? 'ion-footer-modal-tablet'
        : isMobile
          ? 'ion-footer-modal-mobile'
          : 'ion-footer-modal-desktop'
    "
  >
    <div class="buttons-group">
      <ion-button
        class="usf-outline-green-button"
        (click)="close()"
        data-cy="cancel-button"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>

      <ion-button
        class="usf-fill-green-button"
        data-cy="save-button"
        [disabled]="selectedTerritories?.length <= 0"
      >
        {{ 'i18n.common.save' | translate }}
      </ion-button>
    </div>
  </ion-footer>
</ng-container>

<ng-template #mainItem let-territory="territory">
  <div>
    <div class="other-territory-label">
      {{ formatCustomerName(territory) }}
    </div>
    <div class="territory-route-number">
      {{ territory.routeNumber }}
    </div>
  </div>
</ng-template>

<ng-template #myTerritory>
  <div class="bold-label">
    {{ 'i18n.payments.paymentDashboard.myTerritory' | translate }}
  </div>
</ng-template>

<ng-template #selectAll>
  <div class="bold-label">
    {{ 'i18n.payments.paymentDashboard.otherTerritories' | translate }}
  </div>

  <div class="select-all-text">
    {{
      (allSelected ? 'i18n.common.deselectAll' : 'i18n.common.selectAll')
        | translate
    }}
  </div>
</ng-template>
